import { Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { switchMap } from 'rxjs';

/**
 * A signal that ticks on every value/status/touched change of the control, so a zoneless
 * template reading `control.touched` or `control.errors` re-renders after programmatic changes.
 */
export function controlChanges(control: Signal<AbstractControl>): Signal<unknown> {
  return toSignal(toObservable(control).pipe(switchMap((c) => c.events)));
}
